import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import Cookies from "js-cookie";

const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION === "true";

// Add Company management Api

export const createContactList = async (data) => {
    const access_token = Cookies.get("access_token");

    const payload = isEncryptionEnabled
        ? { reqData: encryptData({ ...data, access_token }) }
        : { ...data, access_token };

    try {
        const response = await axios.post(`/contactus-add`, payload);
        const decrypted = isEncryptionEnabled ? decryptData(response) : response.data;
        return decrypted;
    } catch (error) {
        console.error("Error inside createContactList:", error);
        throw error;
    }
};